import React from "react";
import CTA from "./CTA";

import "./header.css";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub, FaInstagram } from "react-icons/fa";

const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h1>Amartya Kumar</h1>
        <h5 className="text-light">Aspiring Full-stack Developer</h5>
        <div className="header__socials">
          <a
            href="https://www.linkedin.com/in/amartya324/"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin />
          </a>
          <a
            href="https://github.com/amartya324"
            target="_blank"
            rel="noreferrer"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.instagram.com/amartya324/"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
        </div>
        <CTA />
        <div className="contact">
          <h3>CONTACT</h3>
          <p>Samastipur, Bihar</p>
          <p>amartya324@gmail.com</p>
          <p>+91 6203729451</p>
        </div>
      </div>
    </header>
  );
};

export default Header;
